import { withTheme } from '@mui/styles';
import styled from 'styled-components';

import config from 'src/config';

function getUrl(index: number, fileName: string) {
  return `url('${config.IMAGE_CDN_HOST}/assets/b2b-landing/banner0${index + 1}${fileName}')`;
}

const IntroductionSection = withTheme(styled.div`
  height: 350vh;

  .sticky {
    position: sticky;
    top: 0;
    height: 100vh;
  }
  .frame {
    z-index: 1;
    position: relative;
    height: 100%;
    width: 100%;
  }

  .banner {
    width: 100%;
    height: 100vh;
    background-size: cover;
    display: flex;
    justify-content: center;
    &.image {
      background-position: left 0px top 50px;
      background-image: ${(props: any) => getUrl(props.bannerIndex, 'x2.jpg')};
      transition: background 400ms ease-in 300ms;
    }
  }
  .sub-header,
  .header {
    font-weight: bold;
    line-height: 1.1;
    color: ${(props: any) => props.theme.palette.primary.dark};
  }
  .header {
    font-size: 48px;
  }
  .sub-header {
    font-size: 36px;
  }
  .sticky-layer {
    display: flex;
  }
  .box-container {
    padding-top: 40px;
  }

  ${(props: any) => props.theme.breakpoints.down('lg')} {
    .header {
      font-size: 36px;
    }
    .sub-header {
      font-size: 24px;
    }
    .box-container {
      padding-top: 16px;
    }
    .banner {
      &.image {
        background-image: ${(props: any) => getUrl(props.bannerIndex, '-tabletx2.jpg')};
        transition: background 400ms ease-in 300ms;
      }
    }
  }
  ${(props: any) => props.theme.breakpoints.down('sm')} {
    .sub-header,
    .header {
      line-height: 1.3;
    }
    .header {
      font-size: 24px;
    }
    .sub-header {
      font-size: 18px;
    }
    .box-container {
      padding-top: 16px;
    }
    .banner {
      &.image {
        background-image: ${(props: any) => getUrl(props.bannerIndex, '-mobilex2.jpg')};
        transition: background 400ms ease-in 300ms;
      }
    }
  }
`);

export default IntroductionSection;
